export default __webpack_public_path__ + "static/media/culture1.7cffcb9f.png";